module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_2.477f22ee.png";